import React from 'react';
import { useLang } from '../context/LanguageContext';
import { HERO_IMAGES } from '../mock';
import useReveal from '../hooks/useReveal';

export default function About() {
  const { t } = useLang();
  const [ref, visible] = useReveal();

  const stats = [
    { v: t('about.stat1v'), l: t('about.stat1') },
    { v: t('about.stat2v'), l: t('about.stat2') },
    { v: t('about.stat3v'), l: t('about.stat3') },
  ];

  return (
    <section id="benvenuti" className="relative py-24 md:py-36 bg-[#F6EFE3] overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto px-5 md:px-10 grid md:grid-cols-2 gap-14 md:gap-20 items-center reveal ${visible ? 'is-visible' : ''}`}>
        {/* Images */}
        <div className="relative">
          <div className="overflow-hidden rounded-[2px] shadow-[0_30px_60px_-20px_rgba(42,36,32,0.4)]">
            <img
              src={HERO_IMAGES.original}
              alt="Sicilia al tramonto"
              className="w-full h-[420px] md:h-[540px] object-cover hover:scale-105 transition-transform duration-[1.2s] ease-out"
            />
          </div>
          <div className="hidden md:block absolute -bottom-10 -right-8 w-56 h-72 overflow-hidden rounded-[2px] shadow-[0_25px_50px_-15px_rgba(42,36,32,0.45)] border-4 border-[#F6EFE3]">
            <img
              src={HERO_IMAGES.town}
              alt="Borgo siciliano"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -top-6 -left-6 w-24 h-24 border-t-2 border-l-2 border-[#D69A4C]/60" />
        </div>

        {/* Text */}
        <div>
          <p className="font-body text-[#B5603A] tracking-[0.35em] uppercase text-xs mb-5">{t('about.kicker')}</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.08] text-[#2A2420] mb-7 whitespace-pre-line">
            {t('about.title')}
          </h2>
          <p className="font-body text-[#6E655B] text-lg leading-relaxed mb-5">{t('about.p1')}</p>
          <p className="font-body text-[#6E655B] text-lg leading-relaxed mb-10">{t('about.p2')}</p>

          <div className="grid grid-cols-3 gap-6 border-t border-[#E7DAC4] pt-8">
            {stats.map((s, i) => (
              <div key={i}>
                <div className="font-display text-3xl md:text-4xl text-[#B5603A] leading-none">{s.v}</div>
                <div className="font-body text-xs md:text-sm text-[#6E655B] mt-2 tracking-wide">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
